import { FrameStatePresenter } from '@/presentation/presenters/frame/frameStatePresenter'
import { FrameStateViewModel } from '@/presentation/viewmodels/frame/frameStateViewModel'

export function useFrameStatePresenter(
  presenter: FrameStatePresenter = new FrameStatePresenter(new FrameStateViewModel())
) {
  return {
    leftSideFrame: presenter.leftSideFrame,
    rightSideFrame: presenter.rightSideFrame,
    isHandlingSlideBar: presenter.isHandlingSlideBar,
    minLeftSideFrameWidth: presenter.minLeftSideFrameWidth,
    maxLeftSideFrameWidth: presenter.maxLeftSideFrameWidth,
    leftSideFrameWidth: presenter.leftSideFrameWidth,
    setLeftSideFrame: presenter.setLeftSideFrame.bind(presenter),
    setRightSideFrame: presenter.setRightSideFrame.bind(presenter),
    setIsHandlingSlideBar: presenter.setIsHandlingSlideBar.bind(presenter),
    mouseDownSlideBar: presenter.mouseDownSlideBar.bind(presenter),
    mouseUpSlideBar: presenter.mouseUpSlideBar.bind(presenter),
    setLeftSideFrameWidth: presenter.setLeftSideFrameWidth.bind(presenter),
    setMaxLeftSideFrameWidth: presenter.setMaxLeftSideFrameWidth.bind(presenter),
    resizeLeftSideFrameWidth: presenter.resizeLeftSideFrameWidth.bind(presenter),
    resizeMaxLeftSideFrameWidth: presenter.resizeMaxLeftSideFrameWidth.bind(presenter),
    initFrameState: presenter.initFrameState.bind(presenter)
  }
}
